import DesktopAlbumCloud from '@/app/about/@desktop/_component/modal/offering/AlbumCloud';
import DesktopAlbumEdit from '@/app/about/@desktop/_component/modal/offering/AlbumEdit';
import DesktopAlbumSort from '@/app/about/@desktop/_component/modal/offering/AlbumSort';
import DesktopCallRecord from '@/app/about/@desktop/_component/modal/offering/CallRecord';
import DesktopCallSearch from '@/app/about/@desktop/_component/modal/offering/CallSearch';
import DesktopCallSummary from '@/app/about/@desktop/_component/modal/offering/CallSummary';
import DesktopCarePremium from '@/app/about/@desktop/_component/modal/offering/CarePremium';
import DesktopContractAuto from '@/app/about/@desktop/_component/modal/offering/ContractAuto';
import DesktopContractView from '@/app/about/@desktop/_component/modal/offering/ContractView';
import DesktopInspectionAlarm from '@/app/about/@desktop/_component/modal/offering/InspectionAlarm';
import DesktopInspectionSupport from '@/app/about/@desktop/_component/modal/offering/InspectionSupport';
import DesktopMonitoringAll from '@/app/about/@desktop/_component/modal/offering/MonitoringAll';
import DesktopMonitoringMy from '@/app/about/@desktop/_component/modal/offering/MonitoringMy';
import DesktopOfferingsRocket from '@/app/about/@desktop/_component/modal/offering/OfferingsRocket';
import DesktopOfferingsSend from '@/app/about/@desktop/_component/modal/offering/OfferingsSend';
import DesktopPropertyFind from '@/app/about/@desktop/_component/modal/offering/PropertyFind';
import DesktopPropertyManage from '@/app/about/@desktop/_component/modal/offering/PropertyManage';
import DesktopPropertyRecommend from '@/app/about/@desktop/_component/modal/offering/PropertyRecommend';
import MobileAlbumCloud from '@/app/about/@mobile/_component/modal/offering/AlbumCloud';
import MobileAlbumEdit from '@/app/about/@mobile/_component/modal/offering/AlbumEdit';
import MobileAlbumSort from '@/app/about/@mobile/_component/modal/offering/AlbumSort';
import MobileCallRecord from '@/app/about/@mobile/_component/modal/offering/CallRecord';
import MobileCallSearch from '@/app/about/@mobile/_component/modal/offering/CallSearch';
import MobileCallSummary from '@/app/about/@mobile/_component/modal/offering/CallSummary';
import MobileCarePremium from '@/app/about/@mobile/_component/modal/offering/CarePremium';
import MobileContractAuto from '@/app/about/@mobile/_component/modal/offering/ContractAuto';
import MobileContractView from '@/app/about/@mobile/_component/modal/offering/ContractView';
import MobileInspectionAlarm from '@/app/about/@mobile/_component/modal/offering/InspectionAlarm';
import MobileInspectionSupport from '@/app/about/@mobile/_component/modal/offering/InspectionSupport';
import MobileMonitoringAll from '@/app/about/@mobile/_component/modal/offering/MonitoringAll';
import MobileMonitoringMy from '@/app/about/@mobile/_component/modal/offering/MonitoringMy';
import MobileOfferingsRocket from '@/app/about/@mobile/_component/modal/offering/OfferingsRocket';
import MobileOfferingsSend from '@/app/about/@mobile/_component/modal/offering/OfferingsSend';
import MobilePropertyFind from '@/app/about/@mobile/_component/modal/offering/PropertyFind';
import MobilePropertyManage from '@/app/about/@mobile/_component/modal/offering/PropertyManage';
import MobilePropertyRecommend from '@/app/about/@mobile/_component/modal/offering/PropertyRecommend';
import type { ContentMapType } from '@/app/about/_types/offeringTypes';

// 컨텐츠 내용 컴포넌트 고르기
export const offeringContentMap: ContentMapType = {
  desktop: {
    contract: [DesktopContractView, DesktopContractAuto],
    album: [DesktopAlbumCloud, DesktopAlbumEdit, DesktopAlbumSort],
    care: [DesktopCarePremium],
    offerings: [DesktopOfferingsSend, DesktopOfferingsRocket],
    call: [DesktopCallRecord, DesktopCallSummary, DesktopCallSearch],
    monitoring: [DesktopMonitoringAll, DesktopMonitoringMy],
    inspection: [DesktopInspectionSupport, DesktopInspectionAlarm],
    property: [DesktopPropertyManage, DesktopPropertyFind, DesktopPropertyRecommend],
  },
  mobile: {
    contract: [MobileContractView, MobileContractAuto],
    album: [MobileAlbumCloud, MobileAlbumEdit, MobileAlbumSort],
    care: [MobileCarePremium],
    offerings: [MobileOfferingsSend, MobileOfferingsRocket],
    call: [MobileCallRecord, MobileCallSummary, MobileCallSearch],
    monitoring: [MobileMonitoringAll, MobileMonitoringMy],
    inspection: [MobileInspectionSupport, MobileInspectionAlarm],
    property: [MobilePropertyManage, MobilePropertyFind, MobilePropertyRecommend],
  },
};
